import { useCallback } from 'react'
import { Button } from '@yes.technology/react-toolkit'
import { FlatActivityModelActionButton } from 'types/shared'
import useActionButtonNavigation from './useActionButtonNavigation'

export type ActivityActionButtonProps = {
  activityModel: FlatActivityModelActionButton
}

const ActivityActionButton = ({ activityModel }: ActivityActionButtonProps) => {
  const { navigateToUrl } = useActionButtonNavigation()

  const handleClick = useCallback(() => {
    if (activityModel.action_type === 'link') {
      navigateToUrl(activityModel.action_data)
    }
  }, [activityModel, navigateToUrl])

  if (activityModel.action_type !== 'link') {
    return null
  }

  return (
    <Button
      onClick={handleClick}
      variant='primary'
      title={activityModel.explanation_text?.des}
    >
      {activityModel.display_text.des}
    </Button>
  )
}

export default ActivityActionButton
